module.exports = __webpack_public_path__ + "static/media/Agent2.becacff1.jpg";